var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicForm',{attrs:{"dynamicFormType":"pre_exam","answerableId":_vm.attendance.id,"answerableType":"Attendance","disabled":_vm.attendanceEsigned}})}
var staticRenderFns = []

export { render, staticRenderFns }